import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => sessionStorage.getItem("eletech_admin_token");
export const setAdminToken = (t) => sessionStorage.setItem("eletech_admin_token", t);
export const clearAdminToken = () => sessionStorage.removeItem("eletech_admin_token");
export const adminHeaders = () => ({ Authorization: `Bearer ${getAdminToken()}` });
